/* PATRICK -> Codice per sliders di larghezza */

class WidthSlider extends HTMLDivElement{

    values;

    constructor(){
        super();
    }
    
    connectedCallback(){
        var slider = this;
        this.values = this.getAttribute("data-values").trimEnd().split(" ").map((val) => parseInt(val)).sort((a,b) => a-b);
        var currently_selected_value;
        var pageURL = new URL(window.location.href);
        var params = pageURL.searchParams;
        if(params.has(this.getAttribute("data-param_name"))){
            currently_selected_value = this.values.indexOf(parseInt(this.dataset.activeValues)) + 1;
        }
        else{
            currently_selected_value = 0;
        }
        noUiSlider.create(slider, {
            start: [currently_selected_value],
            step: 1,
            range: {
                'min': [0],
                'max': [this.values.length]
            },
            orientation: 'horizontal',
        })
        slider.noUiSlider.on('change', () => {
            if(this.noUiSlider.get(true)){
                if(parseInt(params.get(this.getAttribute("data-param_name"))) === this.values.at(this.noUiSlider.get() - 1)){
                    return;
                }
                params.set(this.getAttribute("data-param_name"), this.values.at(this.noUiSlider.get() - 1));
            }
            else{
                if(!params.has(this.getAttribute("data-param_name"))){
                    return;
                }
                else{
                    params.delete(this.getAttribute("data-param_name"));
                }
            }
            
            window.location.href = pageURL;
        });
        slider.noUiSlider.on('update', () => {
            var target = "[data-selector=" + "'" + this.getAttribute("data-target") + "']";
            if(this.noUiSlider.get(true)){
                for(var element of document.querySelectorAll(target)){
                    element.innerText = this.values.at(this.noUiSlider.get() - 1) + "mm";
                }
            }
            else{
                for(var element of document.querySelectorAll(target)){
                    element.innerText = "Nessun filtro";
                }
                element.innerText = "Nessun filtro";
            }
        });
    }
}

customElements.define("width-slider", WidthSlider, {extends: "div"});

/* PATRICK END */

/*marty: selezione taglia ricarico tutto */
class MainProduct extends HTMLElement {
    isChanging = false;

    connectedCallback() {
        this.init();
    }

    init = () => {
        window.addEventListener('variant:change', (e) => {
            this.changeVariant(e.detail.variant.id);
        });
    }

    changeVariant = (variantId) => {
        if(!this.isChanging) {
            this.isChanging = true;
            const url = new URL(window.location.href);
            const params = url.searchParams;
            params.set('variant', variantId);
            axios.get(url).then((response) => {
              const doc = MainProduct.getDocument(response.data);
              const product = doc.querySelector('main-product');
              if(product) {
                this.innerHTML = product.innerHTML;
              }
              this.init();
            }).finally(() => {
              this.isChanging = false;
            });
        }
    }

    static getDocument = (html) => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      return doc;
    }

}
customElements.define("main-product", MainProduct); 


/* REGOLE DI ESCLUSIONE TRATTAMENTI (tipo montatura e/o spessore lente) — versione HARDCODED concordata col cliente.
   Request: docs/requests/2026-09-24-trattamenti-polarizzati-esclusi-rimless-1-6.md (meccanismo), docs/requests/2026-10-13-trattamenti-polarizzati-esclusi-rimless.md (regola attuale)
   Ogni regola nasconde i suoi `trattamenti` quando valgono TUTTE le sue condizioni:
   - tipiMontatura: la montatura ha almeno una di queste voci nel metafield custom.tipo_montatura (admin "Tipo Montatura"). Maiuscole e spazi non contano.
   - spessori: la lente scelta nello step Lenti ha uno di questi spessori, scritti come nel titolo ('1.6'). Si confrontano con l'handle della lente ('-1-6-'), come checkLens().
   - trattamenti: id PRODOTTO dei trattamenti da nascondere (il numero nell'URL admin /admin/products/<id>). `nome` è solo un promemoria, non viene letto.
   Una condizione omessa o vuota vale "qualunque". Senza lente scelta (solo colore / solo trattamento) una regola con spessori non si applica.
   Per aggiungere un trattamento: una riga in `trattamenti`. Per una regola nuova: copiare un blocco { ... }. Si somma al filtro per lente custom.lenti_escluse (isLensAllowed()). */
const TREATMENT_EXCLUSION_RULES = [
    {
        /* Polarizzati mai su montature rimless, qualunque lente e percorso (request 2026-10-13; prima solo con lente 1.6) */
        tipiMontatura: ['Rimless'],
        trattamenti: [
            { id: 15367716405627, nome: 'Da sole Polarizzate' },
            { id: 15367716438395, nome: 'Da sole Polarizzate + Antiriflesso' },
            { id: 15417382502779, nome: 'Da sole Polarizzato (IVA ridotta)' },
            { id: 15417382535547, nome: 'Da sole Polarizzato + Antiriflesso (IVA ridotta)' },
        ],
    },
];

class ConfiguratoreLenti extends HTMLElement {
    /*
        Note generali:
            - Rimossa la possibilitá di mandare la prescrizione via whatsapp. Rimane il codice per gestirla in caso dovesse essere riaggiunta.
    
    */
    constructor() {
        super();
    }
    data = {
        /* Struttura generale degli oggetti:
            steps: enum per dare un nome sensato alle varie fasi, modificare esclusivamente manualmente se si intende aggiungere fasi;
            order: oggetto contenente le informazioni finali per l'ordine, viene aggiornato alla fine di ogni step;
            prescription: oggetto contenente le informazioni dello step prescrizione. Viene aggiornato mentre l'utente inserisce i dati;
            lenses: oggetto contenente le informazioni dello step lenti. Viene aggiornato mentre l'utente sceglie la lente;
            treatment: oggetto contenente le informazioni dello step trattamento. Viene aggiornato mentre l'utente sceglie i trattamenti;
            color: oggetto contenente le informazioni dello step colore e colore_p2. Viene aggiornato mentre l'utente sceglie il colore e le sue varianti;
            
            Alla fine di ogni step, il contenuto di this.order.[NOME STEP] viene aggiornato con il contenuto di this.[NOME STEP]. Color si aggiorna solo alla fine della parte 2, in quanto tutte le informazioni pertinenti all'ordine vengono da questa;
        */
        order: {
            
        },
        steps: {
            PRESCRIPTION: 0, // selezione prescrizione
            LENSES: 1, // selezione lente graduata
            TREATMENT: 2, // selezione trattamento
            TREATMENT_VARIANT: 3, // selezione variante trattamento
            COLORING: 1337, // selezione colore DISABILITATO
            COLORING_p2: 1337, // Selezione Tipologia / intensitá DISABILITATO
        },
        frameType: "", // tipo di occhiale
        lensType: "", // tipo di lente
        rimless: false, // se la montatura è rimless: solo lenti 1.6 e 1.67, con scala per sfera dedicata (vedi calculateAvailableLenses())
        frameKinds: [], // voci di custom.tipo_montatura normalizzate (trim + minuscolo), da data-frame-kinds: condizione `tipiMontatura` di TREATMENT_EXCLUSION_RULES (vedi isExcludedByRule()). [] = nessun vincolo
        flow: [], // flusso calcolato in base alla combinazione occhiale / lente
        totalSteps: 0, // totale step nel flusso corrente (index0 fino a flow.length per includere step di review dell'ordine)
        currentStep: -1, // step attuale nel flusso, -1 se il percorso non é ancora cominciato
        missingInfo: false, // se manca qualche informazione per procedere allo step successivo
        cartError: false, // se l'aggiunta al carrello in finalize() è fallita
        prescription: {
            singleDistance: true, //Se la distanza interpupillare é singola
            missingInfo: false, //Se mancano info relative all'upload della prescrizione
            fileUploaded: false, //Se é stato caricato un file per la prescrizione
            zeroValues: false, //Se almeno un occhio ha sfera e cilindro a zero (prescrizione non compilata per quell'occhio)
        },
        lenses: {},
        treatment: {},
        color: {},
        translateValuesToFlow(lensType, frameType){
            /* Svuota l'array */
            this.flow = [];
            /* Il flusso prescrizione e identico per tutti i tipi di lenti graduate */
            switch (lensType){
                case 'graduate-lontano':
                case 'graduate-vicino':
                case 'graduate-progressive':
                case 'graduate-ufficio':
                    this.flow.push(this.steps.PRESCRIPTION);
                    this.flow.push(this.steps.LENSES)
                    break;
            }
            /* Tutti i flussi hanno la possibilitá di aggiungere un trattamento alle lenti. Questo é l'unico step che viene aggiunto se si seleziona "solo trattamento" */
            this.flow.push(this.steps.TREATMENT);
            this.flow.push(this.steps.TREATMENT_VARIANT); // Gestisce le varianti del trattamento se presenti
            /* Gli occhiali da sole e occhiali da vista con lenti del tipo "solo colore" permettono di cambiare il colore delle lenti */
            /* AGGIUNTA COLORE RIMOSSA PER CAMBIO DI FLUSSO, IL COLORE ADESSO É UNA VARIANTE DI TRATTAMENTO
            if(lensType == 'solo-colore' || frameType == 'occhiali-da-sole'){
                this.flow.push(this.steps.COLORING);
                this.flow.push(this.steps.COLORING_p2);
            }
            */
            /* Setta il numero totale di step e comincia il percorso */
            this.totalSteps = this.flow.length;
            this.currentStep = 0;
        },
        calculateSteps(element){
            /* Funzione usata dal selettore lenti */
            this.reset();
            this.lensType = element.value;
            if(this.lensType == ""){
                return;
            }
            this.order.lensType = this.lensType;
            /* Label localizzata dell'opzione scelta (es. "Da vicino (Ipermetropia/Astigmatismo)"): diventa il valore della line item property "Utilizzo occhiali" in finalize(). Si legge dal DOM invece di mappare gli handle a chiavi i18n dedicate, cosí da riusare le traduzioni giá presenti nelle <option> senza un secondo elenco di testi da tenere allineato. */
            const selectedOption = element.options[element.selectedIndex];
            this.order.lensTypeLabel = selectedOption ? selectedOption.text.trim() : this.lensType;
            this.translateValuesToFlow(this.lensType, this.frameType);
        },
        nextStep(){
            /* In base allo step corrente, controlla se la selezione é valida. In caso positivo, l'ordine viene aggiornato e si passa allo step successivo, altrimenti viene segnalato l'errore */
            switch(this.flow[this.currentStep]){
                case this.steps.PRESCRIPTION:
                        /* Due controlli indipendenti, valutati entrambi prima di uscire: cosí l'utente vede tutti i problemi in una volta invece di scoprirli uno alla volta a ogni click su Avanti. */
                        /* 1) Manca l'informazione su come inviare la prescrizione */
                        this.missingInfo = !(this.prescription.waCheckbox.checked || this.prescription.emailCheckbox.checked || this.prescription.fileUploaded);
                        /* 2) Prescrizione non compilata: il controllo é *per occhio*, non sull'insieme dei quattro campi. Ogni occhio deve avere almeno un valore tra sfera e cilindro: se l'utente compila solo il destro e lascia il sinistro a zero viene bloccato, perché una prescrizione con un occhio vuoto é quasi sempre una compilazione interrotta a metá, non una lente neutra voluta. I campi partono tutti da 0.00, quindi senza questo controllo si passa lo step senza toccare nulla — e con tutti zeri calculateAvailableLenses() sceglierebbe tipo lente e spessori su valori privi di significato. Il controllo vale anche se la prescrizione é stata caricata come file o inviata via email, proprio perché quei valori servono al calcolo delle lenti dello step successivo. L'asse é deliberatamente escluso: da solo non é una correzione, ha senso solo insieme a un cilindro. Il test !parseFloat(v) copre "0.00" e "+0.00" e anche il campo svuotato a mano (parseFloat("") -> NaN, che con un confronto == 0 passerebbe). */
                        const zeroDestro = !parseFloat(this.prescription.sfera_destro.value)
                            && !parseFloat(this.prescription.cilindro_destro.value);
                        const zeroSinistro = !parseFloat(this.prescription.sfera_sinistro.value)
                            && !parseFloat(this.prescription.cilindro_sinistro.value);
                        this.prescription.zeroValues = zeroDestro || zeroSinistro;
                        if(this.missingInfo || this.prescription.zeroValues){
                            return;
                        }
                        /* Valori della prescrizione */
                        this.order.prescription = {
                            sfera_destro: this.prescription.sfera_destro.value,
                            cilindro_destro: this.prescription.cilindro_destro.value,
                            asse_destro: this.prescription.asse_destro.value,
                            sfera_sinistro: this.prescription.sfera_sinistro.value,
                            cilindro_sinistro: this.prescription.cilindro_sinistro.value,
                            asse_sinistro: this.prescription.asse_sinistro.value,

                        }
                        if(this.prescription.singleDistance){
                            this.order.prescription.singleDistance = true;
                            this.order.prescription.dist = this.prescription.dist.value;
                        }
                        else{
                            this.order.prescription.singleDistance = false;
                            this.order.prescription.dist_dx = this.prescription.dist_dx.value;
                            this.order.prescription.dist_sx = this.prescription.dist_sx.value;
                        }
                        /* Metodo di invio della prescrizione */
                        if(this.prescription.fileUploaded){
                            this.order.prescription.send_method = 'File'
                            this.order.prescription.file = this.prescription.fileInput.files[0];
                            this.order.prescription.fileLink = this.prescription.fileLink;
                        }
                        if(this.prescription.waCheckbox.checked){
                            this.order.prescription.send_method = 'WhatsApp';
                        }
                        if(this.prescription.emailCheckbox.checked){
                            this.order.prescription.send_method = 'Email';
                        }
                        this.missingInfo = false;
                        this.currentStep += 1;
                    break;
                /* Gli step per l'aggiunta dei prodotti aggiuntivi sono molto simili tra loro, eccetto il colore */
                case this.steps.LENSES:
                        if(this.lenses.selectedLensElement == undefined){
                            /* Blocca l'utente se non ha selezionato una lente */
                            this.missingInfo = true;
                            return;
                        }
                        const lensEl = this.lenses.selectedLensElement;
                        this.order.lenses = {
                            id: parseInt(lensEl.dataset.id), // id VARIANTE: è quello che finisce in /cart/add.js
                            productId: parseInt(lensEl.dataset.productId), // id PRODOTTO: è la chiave con cui isLensAllowed() confronta le esclusioni dei trattamenti
                            price: lensEl.dataset.price,
                            title: lensEl.dataset.title,
                            handle: lensEl.dataset.handle // handle della lente: le regole per spessore di TREATMENT_EXCLUSION_RULES lo confrontano con '-1-6-' ecc., come checkLens() (vedi isExcludedByRule())
                        };
                        this.missingInfo = false;
                        this.currentStep += 1;
                    break;
                case this.steps.TREATMENT:
                        if(this.treatment.selectedTreatmentElement == undefined){
                            /* Blocca l'utente se non ha selezionato un trattamento */
                            this.missingInfo = true;
                            return;
                        }
                        const treatEl = this.treatment.selectedTreatmentElement;
                        this.order.treatment = {
                            title: treatEl.dataset.title,
                            url: treatEl.dataset.url
                        };
                        this.missingInfo = false;
                        this.currentStep += 1;
                    break;
                case this.steps.TREATMENT_VARIANT:
                        if(this.treatment.selectedVariant == undefined || this.treatment.selectedVariant.length == 0 || this.treatment.selectedVariant.id == undefined){
                            /* Blocca l'utente se non ha selezionato una variante */
                            this.missingInfo = true;
                            return;
                        };
                        this.order.treatment.selectedVariant = this.treatment.selectedVariant;

                        this.missingInfo = false;
                        this.currentStep += 1;
                    break;
                    /** COLORING E COLORING PART 2 SONO DISABILITATI, */
                case this.steps.COLORING:
                        if(this.color.selectedColorElement == undefined){
                            /* Blocca l'utente se non ha selezionato un colore */
                            this.missingInfo = true;
                            return;
                        }
                        this.order.color.url = this.color.selectedColorElement.dataset.url;
                        this.order.color.title = this.color.selectedColorElement.dataset.title;

                        this.missingInfo = false;
                        this.currentStep += 1;
                        
                    break;
                case this.steps.COLORING_p2:
                        if(this.color.selectedVariant == undefined || this.color.selectedVariant.length == 0 || this.color.selectedVariant.id == undefined){
                            /* Blocca l'utente se non ha selezionato una variante */
                            this.missingInfo = true;
                            return;
                        }
                        this.order.color.selectedVariant = this.color.selectedVariant; 

                        this.missingInfo = false;
                        this.currentStep += 1;
                    break;
            }
        },
        previousStep(){
            /* Torna allo step precedente. Il compito di resettare i vari campi viene lasciato agli step in se */
            if(this.currentStep > 0){
                this.currentStep -= 1;
            }
        },
        finalize(){
            /* Traduci this.order nel body per la richiesta /car/add.js. */
            let data = {};
            data.items = [];
            let productData = {
                id: parseInt(document.querySelector('input[name="id"]').value), // ID del prodotto montatura preso al momento per gestire cambio variante.
                quantity: 1,
            }
            /* Chiave di set: lo SKU della montatura viene messo come property tecnica nascosta (prefisso _) su TUTTI i line item (montatura, lente, trattamento), così a valle (carrello/ordine/evasione) si può ricostruire quale lente/trattamento appartiene a quale montatura. Lo SKU si legge dall'input[name="SKU"] (tenuto aggiornato al cambio variante, vedi connectedCallback), con fallback allo SKU renderizzato e infine all'id variante. */
            const setKeyLabel = "_SKU montatura";
            const skuInput = document.querySelector('input[name="SKU"]');
            /* Fonte autorevole = input[name="SKU"] (seed server + sync al cambio variante). Se l'input è presente ma vuoto (variante senza SKU) si ripiega direttamente sull'id variante; this.sku (SKU al render) è usato solo se l'input manca del tutto. */
            let currentSku = "";
            if(skuInput){
                currentSku = skuInput.value.trim();
            } else if(this.sku){
                currentSku = this.sku.trim();
            }
            const setKeyValue = currentSku !== "" ? currentSku : String(productData.id);
            /* Se lo step é presente e siamo arrivati al riepilogo, si puó assumere che i dati siano compilati. Quindi iteriamo gli step per aggiungere i vari prodotti. */
            for(let step of this.flow){
                switch(step){
                    case this.steps.PRESCRIPTION:
                        /* Prescrizione tradotta */
                        productData.properties = JSON.parse(`{
                            "${this.i18n.prescription}": "${this.i18n.right_eye}: ${this.i18n.sphere}: ${this.order.prescription.sfera_destro}, ${this.i18n.cylinder}: ${this.order.prescription.cilindro_destro}, ${this.i18n.axis}: ${this.order.prescription.asse_destro} | ${this.i18n.left_eye}: ${this.i18n.sphere}: ${this.order.prescription.sfera_sinistro}, ${this.i18n.cylinder}: ${this.order.prescription.cilindro_sinistro}, ${this.i18n.axis}: ${this.order.prescription.asse_sinistro}",
                            "${this.i18n.inter_distance}": "${this.order.prescription.singleDistance ? this.order.prescription.dist : this.i18n.right_eye + ': ' + this.order.prescription.dist_dx + ', ' + this.i18n.left_eye + ': ' + this.order.prescription.dist_sx}",
                            "${this.i18n.upload_method}": "${this.order.prescription.send_method}"
                            ${this.order.prescription.send_method == 'File' ? `, "_${this.i18n.prescription_file}": "${this.order.prescription.fileLink}"` : ""}
                        }`);
                    break;
                    case this.steps.LENSES:
                        data.items.push({
                            id: this.order.lenses.id,
                            quantity: 1,
                            properties: { [setKeyLabel]: setKeyValue }
                        });
                    break;
                    case this.steps.TREATMENT:
                        /* Gestito nello step sotto
                        data.items.push({
                            id: this.order.treatment.id,
                            quantity: 1
                        });
                        */
                    break;
                    case this.steps.TREATMENT_VARIANT:
                        data.items.push({
                            id: this.order.treatment.selectedVariant.id,
                            quantity: 1,
                            properties: { [setKeyLabel]: setKeyValue }
                        });
                    break;
                    case this.steps.COLORING_p2:
                        /* Non piú utilizzato */
                        data.items.push({
                            id: this.order.color.selectedVariant.id,
                            quantity: 1,
                            properties: { [setKeyLabel]: setKeyValue }
                        });
                    break;
                }
            }
            /* Chiave di set anche sulla montatura, preservando le properties già costruite dallo step prescrizione */
            productData.properties = productData.properties || {};
            productData.properties[setKeyLabel] = setKeyValue;
            /* Utilizzo occhiali: property VISIBILE (nessun prefisso _) sulla sola montatura, cosí compare in carrello, checkout, email d'ordine e admin (vedi snippets/line-item.liquid, che salta le property con prefisso _). Non serve ripeterla su lente/trattamento: quelle righe sono ricollegabili alla montatura tramite setKeyLabel. Assegnazione diretta sull'oggetto e non dentro il template JSON.parse dello step prescrizione, che interpola valori non escapati. */
            if(this.order.lensTypeLabel){
                productData.properties[this.i18n.usage] = this.order.lensTypeLabel;
            }
            data.items.push(productData);
            /* Aggiungi i prodotti e vai al carrello */
            this.cartError = false;
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-type': "application/json"
                },
                body: JSON.stringify(data)
            }).then(response => {
                if(response.ok){
                    window.location.href = '/cart';
                    return;
                }
                /* Prima di questo ramo un errore del carrello non produceva alcun segnale: il pulsante sembrava semplicemente non fare niente */
                throw new Error(`/cart/add.js ha risposto HTTP ${response.status}`);
            }).catch(error => {
                console.error('ERRORE CONFIGURATORE LENTI:', error);
                this.cartError = true;
            });
        },
        reset(){
            /* Resetta con i valori iniziali */
            this.totalSteps = 0;
            this.flow = [];
            this.currentStep = -1;
            this.order = {};
            this.prescription = {
                singleDistance: true,
                missingInfo: false,
                fileUploaded: false,
                zeroValues: false
            };
            /* this.lenses va azzerato qui: senza, cambiando tipo di lente dopo essere passati dallo step LENSES, lenses.type resta quello del percorso precedente */
            this.lenses = {};
            this.treatment = {};
            this.color = {};
            this.cartError = false;
        },
        clampValue(element, min, max){
            /* Per input dell'asse */
            if(element.value == -1){
                /** Permette di partire da 180 tornando indietro di uno step da 0 */
                element.value = max;
                return;
            }
            if(element.value < min){
                element.value = min;
                return;
            }
            if(element.value > max){
                element.value = max;
                return;
            }
        },
        calculateAvailableLenses(){
            /* Onestamente dovrebbe chiamarsi "initLenses()" */
            /* Svuota le lenti selezionate */
            this.order.lenses = {};
            this.lenses = {};
            /* Calcola sfera e cilindro massimi (in valore assoluto) */
            const maxSphere = Math.max(Math.abs(parseFloat(this.order.prescription.sfera_destro)), Math.abs(parseFloat(this.order.prescription.sfera_sinistro)));
            const maxCylinder = Math.max(Math.abs(parseFloat(this.order.prescription.cilindro_destro)), Math.abs(parseFloat(this.order.prescription.cilindro_sinistro)));
            /* Aggiungere spessori qui in caso di necessitá */
            this.lenses.availableThickness = ['1-5', '1-6', '1-67', '1-74']
            /* Il cilindro massimo determina il tipo di lente. É imperativo che il cilindro rimanga illeso */
            if(maxCylinder > 2.0){
                this.lenses.type = 'costruzione';
            }
            else{
                this.lenses.type = 'serie';
            }
            if(this.rimless){
                /* Montature rimless: scala dedicata al posto di quella generica. Mai 1.5 (troppo spessa per il bordo a vista) né 1.74: sfera fino a 4.00 → 1.6 e 1.67, oltre → solo 1.67. Soglia > 4.0 come la scala generica. Il campo filtra_lenti_per_prescrizione (recommended) qui non si applica: si mostrano sempre tutte le lenti della fascia. Request: docs/requests/2026-10-14-lenti-rimless-solo-1-6-e-1-67.md */
                this.lenses.availableThickness = maxSphere > 4.0 ? ['1-67'] : ['1-6', '1-67'];
            }
            else{
                /* Rimuovi lenti troppo sottili alle varie soglie di sfera */
                if(maxSphere > 2.0){
                    this.lenses.availableThickness.shift();
                }
                if(maxSphere > 4.0){
                    this.lenses.availableThickness.shift();
                }
                if(maxSphere > 8.0){
                    this.lenses.availableThickness.shift();
                }
                if(this.recommended == 'one'){
                    this.lenses.availableThickness.splice(1);
                }
                else {
                    this.lenses.availableThickness.splice(2);
                }
            }
        },
        checkLens(handle){
            /* Compara l'handle del prodotto con le lenti disponibili. NOTA BENE: sarebbe meglio utilizzare un metafield prodotto per evitare futuri errori */
            for(let thickness of this.lenses.availableThickness){
                /* Formattazione per evitare che 1.67 abbia un match con 1.6 */
                let formattedThickness = `-${thickness}-`
                if(handle.includes(formattedThickness)){
                    return true;
                }
            }
            return false;
        },
        isLensAllowed(excludedLensIds){
            /* Filtro di compatibilità trattamento/lente. La lista arriva dal metafield `custom.lenti_escluse` del prodotto trattamento, serializzata da Liquid come CSV di id PRODOTTO: semantica di ESCLUSIONE (elenca le lenti per cui il trattamento NON è disponibile) e fail-open. Decisione: docs/decisions/2026-09-03-compatibilita-trattamenti-per-lente.md */
            if(!excludedLensIds){
                /* Nessuna esclusione dichiarata: disponibile per tutte le lenti (comportamento identico a prima che i metafield fossero popolati) */
                return true;
            }
            const chosenLens = this.order.lenses ? this.order.lenses.productId : undefined;
            if(chosenLens == undefined || isNaN(chosenLens)){
                /* Percorsi che non hanno lo step LENSES nel flusso (solo-colore, solo-trattamento): nessuna lente scelta, nessun filtro da applicare */
                return true;
            }
            return !excludedLensIds.split(',').map(id => id.trim()).includes(String(chosenLens));
        },
        isExcludedByRule(treatmentId){
            /* Regole hardcoded montatura × spessore lente (TREATMENT_EXCLUSION_RULES, in cima al file): true se almeno una regola contiene questo trattamento e ha TUTTE le condizioni vere. Fail-open: dato mancante o malformato = regola non applicata, trattamento visibile. Request: docs/requests/2026-09-24-trattamenti-polarizzati-esclusi-rimless-1-6.md */
            try {
                if(treatmentId == undefined || !Array.isArray(TREATMENT_EXCLUSION_RULES)){
                    return false;
                }
                const frameKinds = Array.isArray(this.frameKinds) ? this.frameKinds : [];
                const lensHandle = this.order && this.order.lenses && typeof this.order.lenses.handle == 'string' ? this.order.lenses.handle : '';
                return TREATMENT_EXCLUSION_RULES.some(rule => {
                    if(!rule || !Array.isArray(rule.trattamenti)){
                        return false;
                    }
                    /* Confronto su stringa: l'id arriva da Liquid come numero, ma non ci si affida al tipo */
                    if(!rule.trattamenti.some(treatment => treatment && treatment.id != undefined && String(treatment.id) === String(treatmentId))){
                        return false;
                    }
                    /* tipiMontatura omessa o vuota = qualunque montatura; altrimenti la montatura deve avere almeno una delle voci (frameKinds è già trim + minuscolo, vedi connectedCallback) */
                    if(Array.isArray(rule.tipiMontatura) && rule.tipiMontatura.length > 0){
                        const ruleKinds = rule.tipiMontatura.map(kind => String(kind).trim().toLowerCase());
                        if(!frameKinds.some(kind => ruleKinds.includes(kind))){
                            return false;
                        }
                    }
                    /* spessori omessa o vuota = qualunque lente; altrimenti serve una lente scelta con uno degli spessori. Tutti i '.' diventano '-' e si cerca '-1-6-' nell'handle: così 1.67 ('-1-67-') non matcha 1.6, come in checkLens() */
                    if(Array.isArray(rule.spessori) && rule.spessori.length > 0){
                        if(!lensHandle){
                            return false;
                        }
                        if(!rule.spessori.some(thickness => lensHandle.includes(`-${String(thickness).trim().split('.').join('-')}-`))){
                            return false;
                        }
                    }
                    return true;
                });
            } catch(e) {
                return false;
            }
        },
        isTreatmentAvailable(excludedLensIds, treatmentId){
            /* Filtro composto della card trattamento: visibile solo se né l'esclusione per lente (custom.lenti_escluse, isLensAllowed()) né le regole hardcoded (isExcludedByRule()) la nascondono */
            return this.isLensAllowed(excludedLensIds) && !this.isExcludedByRule(treatmentId);
        },
        registerTreatment(excludedLensIds, treatmentId){
            /* Ogni card trattamento renderizzata si annuncia qui: così hasAvailableTreatments() sa se lo step è vuoto senza interrogare il DOM */
            if(this.treatment.rendered == undefined){
                this.treatment.rendered = [];
            }
            this.treatment.rendered.push({ excludedLensIds, treatmentId });
        },
        hasAvailableTreatments(){
            /* True se almeno un trattamento della categoria corrente sopravvive al filtro composto (per lente + regole hardcoded) */
            if(this.treatment.rendered == undefined){
                return true;
            }
            return this.treatment.rendered.some(rendered => this.isTreatmentAvailable(rendered.excludedLensIds, rendered.treatmentId));
        },
        async checkUpload(){
                /* Controlla se esiste effettivamente un file nell'input, disabilita le checkbox in caso positivo e autorizza a passare allo step successivo */
                if(this.prescription.fileInput.files.length > 0){
                    this.prescription.waCheckbox.checked = false;
                    this.prescription.emailCheckbox.checked = false;
                    const file = this.prescription.fileInput.files[0];
                    if(file.size > 20 * 1024 * 1024){
                        /* Blocca l'utente se il file é troppo grande (20MB) */
                        this.prescription.fileInput.value = "";
                        this.prescription.fileUploaded = false;
                        this.prescription.fileTooLarge = true;
                        return;
                    }else{
                        this.prescription.fileTooLarge = false;
                    }
                    this.prescription.uploading = true;
                    /* Conversione in base64 */
                    const fileContent = await new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result.split(',')[1]);
                        reader.onerror = error => reject(error);
                        reader.readAsDataURL(file);
                    });
                    /** Data e ora per ordinamento e per evitare conflitti di nome */
                    const now = new Date().toJSON().split('.')[0].replace(/:/g, '-');
                    /** RICHIESTA ALL'APP: 
                     *  - ENDPOINT: /apps/ict_dropbox_uploader/upload_pdf
                     *  - METHOD: POST
                     *  - BODY: {
                     *      file_name: string, -> Nome del file visualizzato su dropbox
                     *      file_content: string (base64) -> Base64 encoding del contenuto del file, senza data URI prefix (es: "data:application/pdf;base64,")
                     *    }
                     * - RISPOSTA DALL'APP:
                     *    - SUCCESSO: 200 OK + URL del file caricato (accessibile solo con credenziali)
                     *    - ERRORE: 400 -> Body non corretto
                     *    - ERRORE: 401 -> validazione della security della richiesta tramite Shopify app proxy incorretta
                     *    - ERRORE: 500 -> Errore interno dell'app durante l'upload (es: problemi di connessione con dropbox o di permessi)
                     */
                    const fileObj = {
                        file_name: `${now}_${file.name}`,
                        file_content: fileContent
                    }
                    fetch('/apps/ict_dropbox_uploader/upload_pdf', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(fileObj)
                    }).then(response => {
                        this.prescription.uploading = false;
                        if(response.ok){
                            /** 200 OK, procedi */
                            this.prescription.uploadError = false;
                            return response.json();
                        }else{
                            /** Errore, segnala all'utente */
                            this.prescription.fileUploaded = false;
                            this.prescription.uploadError = true;
                            this.prescription.fileInput.value = "";
                            throw new Error('Errore durante l\'upload del file');
                        }
                    }).then(data => {
                        /** Data é l'url del file caricato, accessibile solo con credenziali */
                        this.prescription.fileLink = data;
                        this.prescription.fileUploaded = true;
                    });

               }
               else{
                    this.prescription.fileUploaded = false;
               }
        },
        initPrescription(){
            /* Inizializza la prescrizione con i valori precedentemente settati (se esistono) */
            if(this.order.prescription != undefined && Object.keys(this.order.prescription).length > 0){
                /** Dati prescrizione */
                this.prescription.sfera_destro.value = this.order.prescription.sfera_destro;
                this.prescription.cilindro_destro.value = this.order.prescription.cilindro_destro;
                this.prescription.asse_destro.value = this.order.prescription.asse_destro;
                this.prescription.sfera_sinistro.value = this.order.prescription.sfera_sinistro;
                this.prescription.cilindro_sinistro.value = this.order.prescription.cilindro_sinistro;
                this.prescription.asse_sinistro.value = this.order.prescription.asse_sinistro;
                if(this.order.prescription.singleDistance){
                    this.prescription.singleDistance = true;
                    this.prescription.dist.value = this.order.prescription.dist;
                }
                else{
                    this.prescription.singleDistance = false;
                    this.prescription.dist_dx.value = this.order.prescription.dist_dx;
                    this.prescription.dist_sx.value = this.order.prescription.dist_sx;
                }
                /** Se é stato caricato il file, recuperalo e aggiorna l'input per chiarezza */
                if(this.order.prescription.send_method == 'File'){
                    const dataTrasfer = new DataTransfer();
                    dataTrasfer.items.add(this.order.prescription.file);
                    this.prescription.fileInput.files = dataTrasfer.files;
                    this.prescription.fileUploaded = true;
                    this.prescription.fileLink = this.order.prescription.fileLink;
                }
                /** Altrimenti riseleziona il metodo di invio scelto in precedenza dal cliente */
                if(this.order.prescription.send_method == 'WhatsApp'){
                    this.prescription.waCheckbox.checked = true;
                }
                if(this.order.prescription.send_method == 'Email'){
                    this.prescription.emailCheckbox.checked = true;
                }
                
            }
        },
        initTreatment(){
            /* Svuota le scelte */
            this.treatment = {};
            this.order.treatment = {};
            /* Registro delle card renderizzate per la categoria corrente, popolato da registerTreatment() */
            this.treatment.rendered = [];
        },
        initTreatmentVariant(){
            this.treatment.selectedVariant = {};
            this.order.treatment.selectedVariant = {};
            /* Catalogo delle varianti del trattamento e scelta corrente per ogni opzione: sostituiscono opt1/opt2/opt3, che limitavano a tre opzioni per costruzione. Si ripopolano da registerTreatmentVariants() quando la sezione arriva nel DOM; azzerarli qui é ció che rende lo step ripetibile, altrimenti tornando indietro a cambiare trattamento resterebbero appese le varianti di quello precedente. */
            this.treatment.variants = [];
            this.treatment.opts = [];
            this.treatment.variantError = false;
            this.treatment.variantSection = "";
            /* Renderizza la sezione 'helper-treatment' dal prodotto trattamento selezionato nello step precedente */
            fetch(`${this.order.treatment.url}?section_id=helper-treatment`).then(
                response => {
                    /* Un trattamento non pubblicato (o in draft, come nasce per default un duplicato) risponde 404 con il corpo della pagina di errore: senza questo controllo quell'HTML finiva in x-html, lo step restava senza selettore di variante e nextStep() bloccava l'ordine in modo definitivo e silenzioso */
                    if(!response.ok){
                        throw new Error(`helper-treatment non disponibile (HTTP ${response.status})`);
                    }
                    return response.text();
                }
            ).then(
                doc => {
                    /* Dopo aver settato la variabile, alpine pensa al html in se */
                    this.treatment.variantSection = doc;
                }
            ).catch(
                error => {
                    console.error('ERRORE CONFIGURATORE LENTI:', error);
                    this.treatment.variantSection = "";
                    this.treatment.variantError = true;
                }
            )
        },
        registerTreatmentVariants(payload){
            /* Catalogo delle varianti emesso dalla sezione helper-treatment in un data attribute. Qui il JSON é DATO e viene parsato, non interpolato in un'espressione: é questo che permette ai nomi valore di contenere apostrofi e virgolette (cosa che il data-i18n del web component, con i suoi apici singoli, non si puó permettere). */
            try{
                this.treatment.variants = JSON.parse(payload);
            }
            catch(error){
                /* Catalogo illeggibile: meglio lo stesso errore esplicito del trattamento non pubblicato che dei select vuoti senza spiegazione */
                console.error('ERRORE CONFIGURATORE LENTI:', error);
                this.treatment.variants = [];
                this.treatment.opts = [];
                this.treatment.variantError = true;
                return;
            }
            /* Una scelta vuota per ogni opzione: quante siano lo dice la prima variante, dato che tutte le varianti di un prodotto hanno lo stesso numero di opzioni */
            const optionCount = this.treatment.variants.length > 0 ? this.treatment.variants[0].values.length : 0;
            this.treatment.opts = new Array(optionCount).fill("");
            this.treatment.selectedVariant = {};
        },
        treatmentVariantMatchesChoices(variant, upToIndex){
            /* Vero se la variante combacia con le scelte giá fatte nelle opzioni 0..upToIndex-1. Un'opzione ancora da scegliere non vincola: all'apertura dello step ogni select elenca tutto ció che esiste in almeno una variante. */
            for(let i = 0; i < upToIndex; i++){
                const chosen = this.treatment.opts[i];
                if(!chosen){
                    continue;
                }
                if(variant.values[i] == undefined || String(variant.values[i].id) !== String(chosen)){
                    return false;
                }
            }
            return true;
        },
        treatmentOptionValues(index){
            /* Valori selezionabili per l'opzione in posizione `index`: solo quelli per cui esiste davvero una variante, date le scelte fatte a monte (filtro "a cascata"). Stessa semantica del product_option_value.available di Shopify, ma calcolata qui: niente fetch della sezione a ogni change, quindi niente latenza e niente nuovi stati di errore da gestire. Il filtro é top-down — le opzioni a valle non vincolano quelle a monte, altrimenti l'utente resterebbe prigioniero della propria prima scelta. Deliberatamente NON si guarda la disponibilitá a magazzino: i trattamenti sono prestazioni, non stock. */
            const variants = this.treatment.variants || [];
            const seen = [];
            const values = [];
            for(let variant of variants){
                if(!this.treatmentVariantMatchesChoices(variant, index)){
                    continue;
                }
                const value = variant.values[index];
                /* Deduplica per id: lo stesso valore compare in tante varianti quante sono le combinazioni che lo usano. L'ordine é quello di prima comparsa, cioé l'ordine delle varianti deciso in admin. */
                if(value == undefined || seen.includes(String(value.id))){
                    continue;
                }
                seen.push(String(value.id));
                values.push(value);
            }
            return values;
        },
        selectTreatmentOption(index, valueId){
            this.treatment.opts[index] = valueId;
            /* Cambiando un'opzione a monte, le scelte a valle possono restare senza variante: si azzerano in ordine, perché ogni azzeramento allarga la lista di quella dopo. Una scelta ancora valida non si tocca, cosí l'utente non ricomincia da capo per nulla. */
            for(let k = index + 1; k < this.treatment.opts.length; k++){
                const chosen = this.treatment.opts[k];
                if(!chosen){
                    continue;
                }
                const stillAvailable = this.treatmentOptionValues(k).some(value => String(value.id) === String(chosen));
                if(!stillAvailable){
                    this.treatment.opts[k] = "";
                }
            }
            this.updateSelectedTreatmentVariant();
        },
        updateSelectedTreatmentVariant(){
            /* La variante non viene piú annunciata dal markup (un template x-if per ogni variante) ma DERIVATA dallo stato dei select. É ció che chiude il bug della selezione stantia: prima, cambiando un'opzione verso una combinazione inesistente, il template si smontava e basta, selectedVariant restava quella di prima e a carrello finiva una variante che l'utente non vedeva piú selezionata. */
            const opts = this.treatment.opts || [];
            const complete = opts.length > 0 && opts.every(chosen => chosen != undefined && chosen !== "");
            if(!complete){
                this.treatment.selectedVariant = {};
                return;
            }
            const match = (this.treatment.variants || []).find(
                variant => opts.every((chosen, index) => variant.values[index] != undefined && String(variant.values[index].id) === String(chosen))
            );
            if(match == undefined){
                /* Non dovrebbe accadere, il filtro a cascata propone solo combinazioni esistenti: ma se accade é meglio bloccare che ordinare a caso */
                this.treatment.selectedVariant = {};
                return;
            }
            this.treatment.selectedVariant = {
                id: match.id,
                price: match.price, // in centesimi, come tutti i prezzi del configuratore (vedi formatMoney())
                variantName: match.values.map(value => value.name).join(' - '), // formato invariato: lo leggono il riepilogo (order.treatment.selectedVariant.variantName) e finalize()
                image: match.image
            };
        },
        /* initColoring(), initColoringPartTwo() e setSelectedColorVariant() non vengono piú utilizzati, rimangono in codice per sicurezza */
        initColoring(){
            /* Svuota le scelte */
            this.color = {};
            this.order.color = {};
        },
        initColoringPartTwo(){
            /* Nome terribile ma cosa vuoi farci */
            this.color.selectedVariant = {};
            this.order.color.selectedVariant = {};
            /* Renderizza la sezione 'helper-lens_color' dal prodotto colore selezionato nello step precedente */
            fetch(`${this.order.color.url}?section_id=helper-lens_color`).then(
                response => {
                    return response.text();
                }
            ).then(
                doc => {
                    /* Dopo aver settato la variabile, alpine pensa al html in se */
                    this.color.productSection = doc;
                }
            )
        },
        setSelectedTreatmentVariant(value){
            /* La variante selezionata arriva tramite JSON dall'opzione scelta */
            this.treatment.selectedVariant = JSON.parse(value);
        },
        setSelectedColorVariant(value){
            /* La variante selezionata arriva tramite JSON dall'opzione scelta */
            this.color.selectedVariant = JSON.parse(value);
        },
        formatMoney(cash){
            /* Very CASHMONEY */
            const cents = parseFloat(cash);
            const wholes = cents / 100;
            return `${this.currency}${wholes.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
        },
        calculateTotal(){
            /* Calcola il totale per il riepilogo ordine e ritorna il valore in centesimi */
            let total = this.mainProductPrice;
            for(let step of this.flow){
                switch(step){
                    case this.steps.LENSES:
                        total += parseFloat(this.order.lenses.price);
                    break;
                    case this.steps.TREATMENT:
                        //total += parseFloat(this.order.treatment.price); // RIMOSSO: il prezzo viene gestito dalla variante di trattamento
                    break;
                    case this.steps.TREATMENT_VARIANT:
                        total += parseFloat(this.order.treatment.selectedVariant.price);
                    break;
                    case this.steps.COLORING_p2:
                        total += parseFloat(this.order.color.selectedVariant.price);
                    break;
                }
            }
            return total;
        },
        isFarLensType(){
            return this.lensType == 'graduate-lontano' || this.lensType == 'graduate-progressive';
        },
        isNearLensType(){
            return this.lensType == 'graduate-vicino';
        }
    };

    connectedCallback(){
        if(this.dataset.frameType != undefined){
            this.data.frameType = this.dataset.frameType;
        }
        else{
            console.error('ERRORE CONFIGURATORE LENTI: non é stato definito il tipo di occhiale');
        }
        this.data.recommended = this.dataset.recommended; // 'all' o 'one', determina se mostrare tutte le opzioni di spessore lente o solo la prima raccomandata
        this.data.rimless = this.dataset.rimless === 'true'; // Montatura rimless (da custom.tipo_montatura): solo lenti 1.6 e 1.67 con scala dedicata in calculateAvailableLenses(). Attributo assente o 'false' = scala generica
        /* Voci di custom.tipo_montatura (JSON della lista, da data-frame-kinds) per la condizione tipiMontatura di TREATMENT_EXCLUSION_RULES, normalizzate trim + minuscolo. Attributo assente, null o malformato = [] (fail-open: nessuna regola per tipo montatura si applica) */
        this.data.frameKinds = [];
        try {
            const frameKinds = JSON.parse(this.dataset.frameKinds);
            if(Array.isArray(frameKinds)){
                this.data.frameKinds = frameKinds.map(v => String(v).trim().toLowerCase());
            }
        } catch(e) {
            this.data.frameKinds = [];
        }
        this.data.sku = this.dataset.sku; // SKU della variante montatura al render (valore iniziale/fallback): chiave di set per legare lente/trattamento alla montatura (vedi finalize())
        this.data.currency = this.dataset.currency; // Simbolo della valuta
        //this.data.mainProductId = parseInt(document.querySelector('input[name="id"]').value); // ID del prodotto montatura OLD
        this.data.mainProductPrice = parseFloat(this.dataset.price); // Prezzo del prodotto montatura in centesimi
        this.data.i18n = JSON.parse(this.dataset.i18n); // Traduzioni
        /* Il variant picker del tema aggiorna solo input[name="id"] al cambio variante (evento 'variant:change' sul form, bubbling). L'input[name="SKU"] custom non viene toccato: lo sincronizziamo qui con lo SKU della variante correntemente selezionata, cosí che finalize() legga sempre il valore giusto anche se la variante viene cambiata prima di configurare. */
        document.addEventListener('variant:change', (event) => {
            const variant = event.detail && event.detail.variant;
            if(!variant) return;
            const skuInput = document.querySelector('input[name="SKU"]');
            if(skuInput) skuInput.value = variant.sku || '';
        });
        Alpine.data('configuratore', () => {
            return this.data;
        })
    }
}
customElements.define("configuratore-lenti", ConfiguratoreLenti); 